<template>
  <div>
    <MovieContainer
      v-if="element.component === 'movie'"
      :movieId="element.id"
      :model="model"
    />
    <PictureContainer
      v-else-if="element.component === 'picture'"
      :picture="element"
      :model="model"
    />
    <div v-else>
      {{$t('video_watch.not_available')}}
    </div>
  </div>
</template>
<script>
import PictureContainer from "../PostContainer/PictureContainer"
import MovieContainer from "../PostContainer/MovieContainer"

export default {
  name: 'PostContainer',
  components: {PictureContainer, MovieContainer},
  props: {
    element: {},
    model: {}
  }
}
</script>